import React from 'react';
import { Section, SectionSubTitle, Typography } from 'common/components';
import { createElementKey } from 'utils';
import {
  DESIGN_STUDIO_BENEFITS_LIST,
  DesignStudioBenefitsListStructure,
} from './design-studio-benefits-constants';
import { benefitsList, benefitText, designStudioBenefitsSection } from './design-studio-benefits-styles';

export const DesignStudioBenefits = () => (
  <Section className={designStudioBenefitsSection}>
    <SectionSubTitle margin="m">С&nbsp;дизайн-проектом вы&nbsp;сможете</SectionSubTitle>
    <ul className={benefitsList}>
      {DESIGN_STUDIO_BENEFITS_LIST.map(
        ({ icon, text }: DesignStudioBenefitsListStructure, index: number) => (
          <li key={createElementKey('benefit', index)}>
            {icon}
            <Typography className={benefitText} variant="m" size="body_long">
              {text}
            </Typography>
          </li>
        )
      )}
    </ul>
  </Section>
);
